import { sb } from '../supabase';

// «مركز الموافقات» — Growth Director Phase B (owner, 2026-11-03). Proposals are
// read through RLS (the owner only) and decided only through the database
// functions, which check is_growth_owner() themselves: growth_proposal_decide,
// growth_proposal_keep, growth_proposal_measure_manual. Nothing here writes the
// table. Migration 20261103070000_growth_director_phase_b_proposals.sql.

export const PROPOSAL_STATUS_AR = {
  pending: 'بانتظار قرارك', approved: 'معتمد', rejected: 'مرفوض', changes_requested: 'مطلوب تعديله',
  superseded: 'استُبدل بأحدث', expired: 'انتهى',
};
export const KIND_AR = { decision: 'قرار لـ«القرارات»', action: 'إجراء' };
export const METRIC_AR = {
  paid_orders: 'طلبات مدفوعة', new_paying_customers: 'عملاء جدد يدفعون', revenue_sar: 'إيراد صافٍ (ر.س)', sessions: 'جلسات',
  cart_sessions: 'جلسات أضافت للسلة', cost_per_new_paying_customer_sar: 'تكلفة العميل الجديد الذي يدفع (ر.س)', manual: 'يُقاس يدوياً',
};
export const TABS = [
  ['pending', 'بانتظار قرارك'], ['approved', 'معتمد'], ['rejected', 'مرفوض'], ['all', 'الكل'],
];

const COLS = 'id, ref, kind, topic_key, title_ar, decision_text, problem, evidence, action, expected_result, expected_metric, expected_value, expected_by, '
  + 'cost_sar, risk, parent_id, new_evidence, source, created_at, status, decided_at, decided_via, decision_reason, kept_at, baseline_value, measured_value, measured_at, measured_note';

export async function fetchProposals(tab = 'pending', limit = 200) {
  let q = sb.from('growth_proposals').select(COLS).order('created_at', { ascending: false }).limit(limit);
  if (tab === 'rejected') q = q.in('status', ['rejected', 'changes_requested']);
  else if (tab !== 'all') q = q.eq('status', tab);
  const { data, error } = await q;
  if (error) throw error;
  return data || [];
}
export async function fetchProposal(id) {
  const { data, error } = await sb.from('growth_proposals').select(COLS).eq('id', id).maybeSingle();
  if (error) throw error;
  return data;
}
export async function fetchPendingCount() {
  const { count, error } = await sb.from('growth_proposals').select('id', { count: 'exact', head: true }).eq('status', 'pending');
  if (error) throw error;
  return count || 0;
}
export async function fetchSummary(id) {
  const { data, error } = await sb.rpc('growth_proposal_summary_ar', { p_id: id });
  if (error) throw error;
  return data || '';
}

// The database answers { ok, ... } or { ok: false, error }; an RPC error throws.
async function rpcResult(name, args) {
  const { data, error } = await sb.rpc(name, args);
  if (error) throw error;
  return data;
}
export const decideProposal = (id, decision, reason) =>
  rpcResult('growth_proposal_decide', { p_id: id, p_decision: decision, p_reason: reason?.trim() ? reason.trim() : null });
export const keepProposal = (id) => rpcResult('growth_proposal_keep', { p_id: id });
export const measureManual = (id, value, note) =>
  rpcResult('growth_proposal_measure_manual', { p_id: id, p_value: Number(value), p_note: note || '' });

// What to show after a decision — the same meanings as the WhatsApp replies.
export function decisionMessage(r) {
  if (r?.ok) {
    if (r.kept) return `${r.ref} محفوظ بدون انتهاء لين تقرر.`;
    if (r.status === 'approved') return r.kind === 'decision' ? `اعتمدت ${r.ref} وانضاف لـ«القرارات».` : `اعتمدت ${r.ref}.`;
    if (r.status === 'rejected') return `رفضت ${r.ref}.`;
    return `رجّعت ${r.ref} للمدير مع التعديل المطلوب.`;
  }
  if (r?.error === 'reason_required') return 'اكتب السبب أولاً.';
  if (r?.error === 'already_kept') return 'محفوظ من قبل.';
  if (String(r?.error || '').startsWith('already_')) return `تقرر من قبل (${PROPOSAL_STATUS_AR[String(r.error).slice(8)] || ''}).`;
  if (r?.error === 'not_found') return 'ما لقيت المقترح.';
  return 'تعذّر الحفظ.';
}

// Pending: when it expires (14 days unless kept — owner, 2026-11-03).
export function expiryText(p, now = Date.now()) {
  if (p.status !== 'pending') return null;
  if (p.kept_at) return 'محفوظ لين تقرر';
  const left = Math.ceil((new Date(p.created_at).getTime() + 14 * 864e5 - now) / 864e5);
  return left > 0 ? `ينتهي بعد ${left} يوم ما لم تحفظه` : 'ينتهي الليلة';
}

// expected vs measured, in words; a result after approval is not proof it caused it
export function resultText(p) {
  if (p.kind !== 'action' || p.status !== 'approved') return null;
  const unit = METRIC_AR[p.expected_metric] || '';
  if (p.measured_value == null) return p.expected_metric === 'manual' ? 'بانتظار قياسك' : `يُقاس بعد ${p.expected_by}`;
  const fmt = (n) => (n == null ? '—' : Number(n).toLocaleString('en-US', { maximumFractionDigits: 2 }));
  return `المتوقع ${fmt(p.expected_value)} · الفعلي ${fmt(p.measured_value)} · قبلها ${fmt(p.baseline_value)} (${unit})`;
}
